import { Controller } from "stimulus";
import { trackPagePulse } from "../global/page_pulse";


export default class extends Controller {
    static targets = ['revealPhone', 'revealWebsite', 'revealFacebook', 'revealInstagram'];
    static values = {
        id: Number
    }

    revealPhoneTargetConnected() {
        this.revealPhoneTarget.addEventListener('click', async (event) => {
            event.preventDefault();

            try {
                const res = await fetch(`/api/v1/reveal_phone/${this.idValue }`, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!res.ok) throw new Error(`Fetch error: ${res.status}`);
                const data = await res.json();
                const phone = data.phone || data.number || data;
                this.revealPhoneTarget.innerHTML = `<a href="tel:${phone}" class="text-nepal-800">${phone}</a>`;
                trackPagePulse("contact_phone", { subjectType: "location", subjectId: this.idValue });
                _mtm.push({ event: "contact_click", type: "phone" });
                //console.log('Phone revealed:', phone);
            } catch (err) {
                console.error('Failed to fetch phone:', err);
            }
        }, { once: true });
    }

    revealWebsiteTargetConnected() {
        this.revealWebsiteTarget.addEventListener('click', async (event) => {
            event.preventDefault();

            try {
                const res = await fetch(`/api/v1/reveal_website/${this.idValue }`, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!res.ok) throw new Error(`Fetch error: ${res.status}`);
                const data = await res.json();
                let website = data.website;

                if (!data || !data.website || data.website.trim() === '') {
                    return;
                }

                if (!/^https?:\/\//i.test(website)) {
                    website = 'https://' + website.trim();
                }

                this.revealWebsiteTarget.innerHTML = `<a class="text-nepal-800" rel="nofollow" target="_blank" href="${website}">Website</a>`;
                trackPagePulse("contact_website", { subjectType: "location", subjectId: this.idValue });
                _mtm.push({ event: "contact_click", type: "website" });
                //console.log('Website revealed:', website);
            } catch (err) {
                console.error('Failed to fetch website:', err);
            }
        }, { once: true });
    }

    revealFacebookTargetConnected() {
        this.revealFacebookTarget.addEventListener('click', async (event) => {
            event.preventDefault();

            try {
                const res = await fetch(`/api/v1/reveal_facebook/${this.idValue }`, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!res.ok) throw new Error(`Fetch error: ${res.status}`);
                const data = await res.json();
                let facebook = data.facebook;

                if (!data || !data.facebook || data.facebook.trim() === '') {
                    return;
                }

                if (!/^https?:\/\//i.test(facebook)) {
                    facebook = 'https://' + facebook.trim();
                }

                this.revealFacebookTarget.innerHTML = `<a class="text-nepal-800" rel="nofollow" target="_blank" href="${facebook}">Facebook</a>`;
                trackPagePulse("contact_facebook", { subjectType: "location", subjectId: this.idValue });
                _mtm.push({ event: "contact_click", type: "facebook" });
                //console.log('Facebook revealed:', facebook);
            } catch (err) {
                console.error('Failed to fetch facebook:', err);
            }
        }, { once: true });
    }

    revealInstagramTargetConnected() {
        this.revealInstagramTarget.addEventListener('click', async (event) => {
            event.preventDefault();

            try {
                const res = await fetch(`/api/v1/reveal_instagram/${this.idValue }`, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!res.ok) throw new Error(`Fetch error: ${res.status}`);
                const data = await res.json();
                let instagram = data.instagram || data.url || data;

                if (!data || !data.instagram || data.instagram.trim() === '') {
                    return;
                }

                if (!/^https?:\/\//i.test(instagram)) {
                    instagram = 'https://' + instagram.trim();
                }
                this.revealInstagramTarget.innerHTML = `<a class="text-nepal-800" rel="nofollow" target="_blank" href="${instagram}">Instagram</a>`;
                trackPagePulse("contact_instagram", { subjectType: "location", subjectId: this.idValue });
                _mtm.push({ event: "contact_click", type: "instagram" });
                //console.log('Instagram revealed:', instagram);
            } catch (err) {
                console.error('Failed to fetch instagram:', err);
            }
        }, { once: true });
    }
}
